module.exports = __webpack_public_path__ + "img/xiyiji.a1b7a31e.png";